import PropTypes from 'prop-types';
import '../pages/AuthCommon.css';

const AuthLayout = ({ children, title, description, icon, className, wide, compact }) => {
  return (
    <div className="auth-layout-wrapper">
      {icon && (
        <div className="auth-layout-icon-container">
          {icon}
        </div>
      )}
      <div className={`auth-card ${wide ? 'auth-card-wide' : ''} ${className || ''}`}>
        {(title || description) && (
          <div className="auth-card-header">
            {title && <h2 className="auth-card-title">{title}</h2>}
            {description && <p className="auth-card-description">{description}</p>}
          </div>
        )}
        <div className={`${compact ? 'auth-card-content-compact' : 'auth-card-content'} ${title || description ? '' : (compact ? 'auth-card-content-compact-no-header' : 'auth-card-content-no-header')}`}>
          {children}
        </div>
      </div>
      <div className="auth-layout-spacer" />
    </div>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node,
  className: PropTypes.string,
  wide: PropTypes.bool,
  compact: PropTypes.bool,
};

AuthLayout.defaultProps = {
  title: null,
  description: null,
  icon: null,
  className: '',
  wide: false,
  compact: false,
};

export default AuthLayout;
